import { createConfirmation } from 'react-confirm'
import ConfirmationDialog from './ConfirmationDialog'
import ConfirmationDialogIrreversible from './ConfirmationDialogIrreversible'

export const confirmationDialogIrreversible = createConfirmation(ConfirmationDialogIrreversible)
export const confirmationDialog = createConfirmation(ConfirmationDialog)